/**
 * Canonical error body returned by every authenticated 401 (the auth proxy and
 * `withAuthentication`/`handleAuthError`). The client uses this to distinguish a
 * genuinely expired app session from upstream 401s that routes forward (e.g. a
 * GitHub "Bad credentials" error), which must not trigger a sign-in redirect.
 */
export const AUTHENTICATION_REQUIRED_ERROR = 'Authentication required';
